import {combineReducers} from "redux";
import login from "./login.reducer.js";
import user from "./user.reducer.js";

const authReducers = combineReducers({
  user,
  login,
});

export default authReducers;
